<template lang="pug">
.JoinClassLayer.allow-replication
  .JoinClassContent
    i.iconfont.closeIcon(@click.self='close') &#xe60a;
    h4.title 加入班级
    h5.importantTip(v-if='tip') {{ tip }}
    km-form.JoinClassForm(:models='$data', :rules='rules', ref='form', labelWidth='58px')
      km-form-item.bjmFormItem(label='班级码', prop='classCode', ref='classCode')
        km-input.warp(
          iconPosition='right',
          :showClearIcon='false',
          v-model.trim='classCode',
          @blur='checkHandle',
          placeholder='请输入6位班级码'
        )
          span.helpIcon(slot='icon') ?
            span.tip 亲爱的同学，你好！班级码由学校或班级教师统一发放，请联系教师或客服400-018-9011获取。
        km-button.check_button(isBack='true', @click='checkHandle') {{ checking ? "验证..." : "验证" }}
      km-form-item.classCodeInfo(label='', v-if='classCodeInfo')
        p {{ classCodeInfo.grade.name + classCodeInfo.schoolClass.name }}
        p.opacity_8 {{ classCodeInfo.school.name }}
        p.opacity_6 {{ classCodeInfo.region.city.name + classCodeInfo.region.country.name }}
      km-form-item(label='姓名', prop='fullname', ref='reName', v-if='isRename')
        km-input.warp(
          v-model.trim='fullname',
          :maxlength='16',
          :showClearIcon='false',
          placeholder='请填写真实姓名'
        )
      km-form-item.importantTip.errorinfo(label='', v-show='errorinfo') {{ errorinfo }}
      km-form-item.buttonItem
        km-button.joinClass-cancel-btn(:isBorder='true', @click='close') 取消
        km-button.joinClass-confirm-btn(
          :class='{ disabled: !isPass }',
          :type='saveButtonCurrentType',
          :disabled='!isPass',
          :isBack='true',
          @click='savehandle'
        ) 加入班级
</template>

<script>
import { validateClassCode, authStore, changeStudentClassBat } from '@/api'
export default {
  data() {
    return {
      classCode: '',
      fullname: '',
      hasClass: false,
      resolve: () => { },
      reject: () => { },
      classCodeInfo: null,
      errorinfo: '',
      tip: '',
      saveButtonCurrentType: '',
      isPass: false,
      checking: false,
      isRename: false,
      studentId: '',
      oldCode: '', // 上一次验证成功的班级码
      rules: {
        fullname: [
          {
            required: true,
            message: '请填写真实姓名',
            trigger: 'blur'
          }
        ],
        classCode: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback('请输入班级码')
              } else if (value.length !== 6) {
                callback('班级码为6位“数字+字母”组合，请确认后重新输入')
              } else if (this.isPass) {
                callback()
              } else {
                validateClassCode({
                  classCode: this.classCode
                }).then(res => {
                  if (res.status === 1) {
                    this.classCodeInfo = res.data
                    callback()
                  } else {
                    callback(res.info)
                  }
                })
              }
            },
            trigger: 'click'
          }
        ]
      }
    }
  },
  watch: {
    classCode(v) {
      this.errorinfo = ''
      this.isPass = v && v === this.oldCode
    },
    fullname() {
      this.errorinfo = ''
    }
  },
  methods: {
    savehandle() {
      this.saveButtonCurrentType = 'loading'
      this.save()
        .then(res => {
          this.saveButtonCurrentType = ''
        })
        .catch(error => {
          console.log(error)
          this.saveButtonCurrentType = ''
        })
    },
    async save() {
      this.errorinfo = ''
      await this.$refs.form.validate()
      let res = {}
      if (this.hasClass) {
        res = await changeStudentClassBat({
          studentId: this.studentId,
          targetClassCode: this.classCode,
          hash: '20190815_synStudentCmp_qqq',
          fullname: this.isRename ? this.fullname : ''
        })
      } else {
        res = await authStore({
          type: 'classCode',
          classCode: this.classCode,
          ...(this.isRename ? { fullname: this.fullname } : {})
        })
      }
      if (res.status === 1) {
        this.$el.parentElement.removeChild(this.$el)
        this.resolve(res)
      } else if (res.status === 30101) {
        // 重名
        this.isRename = true
        this.$nextTick(() => {
          this.$refs.reName.errortip = res.info
        })
      } else if (res.status === 30201) {
        this.oldCode = ''
        this.isPass = false
        this.classCodeInfo = null
        this.$refs.classCode.errortip = res.info
      } else {
        this.errorinfo = res.info
      }
    },
    checkHandle() {
      if (this.checking) return
      this.classCode = this.classCode.replace(/\s/g, '')
      this.checking = true
      this.$refs.classCode.validate('', errors => {
        this.checking = false
        if (errors) {
          this.oldCode = ''
          this.classCodeInfo = null
          this.isPass = false
        } else {
          this.oldCode = this.classCode
          this.isPass = true
        }
      })
    },
    close() {
      if (this.saveButtonCurrentType) return
      this.$el.parentElement.removeChild(this.$el)
      this.reject()
    }
  },
  mounted() { }
}
</script>

<style lang="less" scoped>
.JoinClassLayer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.JoinClassContent {
  padding: 30px 39px;
  background: white;
  width: 400px;
  border-radius: 10px;
  min-height: 277px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.closeIcon {
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.title {
  margin-top: 10px;
  text-align: center;
  line-height: 28px;
  font-size: 20px;
  font-weight: normal;
}
.JoinClassForm {
  margin-top: 15px;
  padding-bottom: 40px;
}
.helpIcon {
  display: inline-block;
  border: 1px solid #21bd73;
  border-radius: 50%;
  color: #21bd73;
  font-weight: bold;
  width: 16px;
  height: 16px;
  line-height: 14px;
  text-align: center;
  position: relative;
  .tip {
    display: none;
    background: rgba(36, 204, 124, 1);
    width: 200px;
    position: absolute;
    top: -90px;
    left: -152px;
    font-weight: normal;
    text-align: left;
  }
  .tip::after {
    left: 80%;
  }
}
.helpIcon:hover .tip {
  display: block;
  font-weight: normal;
}
.buttonItem {
  position: absolute;
  bottom: 0;
}
.importantTip {
  text-align: left;
  margin-top: 20px;
  font-style: 14px;
  font-weight: normal;
  color: #666;
}
.check_button {
  font-size: 14px !important;
  width: 45px !important;
  height: 30px !important;
  background: #21bd73;
  border-radius: 0px !important;
  line-height: 30px !important;
  margin-left: 5px;
}
</style>
<style lang="less">
.JoinClassLayer {
  .errorinfo {
    text-align: center;
    .content {
      margin-left: 0px !important;
      color: #ff6666;
    }
  }
  .classCodeInfo {
    margin-top: -18px;
    .content {
      display: block;
      background: #f8f8f8;
      padding: 5px 0 7px 10px;
      width: 214px;
    }
    p {
      margin-top: 4px;
      color: #333;
      width: 204px;
    }
    p:first-child {
      margin-top: 0px;
    }
    .opacity_8 {
      opacity: 0.8;
    }
    .opacity_6 {
      opacity: 0.6;
    }
  }
  .form-input {
    width: 214px !important;
    height: 30px !important;
  }
  .label {
    padding-right: 4px !important;
  }
  .errortip {
    left: 0 !important;
    top: 31px !important;
    margin-left: 0 !important;
    font-size: 12px !important;
  }
  .joinClass-cancel-btn,
  .joinClass-confirm-btn {
    height: 40px !important;
    line-height: 40px !important;
  }
  .form-input > div {
    width: 16px !important;
    height: 28px !important;
    margin-right: 10px !important;
    background-color: white !important;
  }
  .joinClass-confirm-btn {
    margin-left: 30px;
  }
  .joinClass-confirm-btn.disabled {
    background: rgba(33, 189, 115, 0.6) !important;
  }
  .joinClass-confirm-btn.disabled:hover {
    background: rgba(33, 189, 115, 0.6) !important;
  }
  label.required::before {
    content: '' !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/JoinClass/app.vue